import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from '../../components/customer/Header';
import Footer from '../../components/customer/Footer';
import Button from '../../components/common/Button';
import Input from '../../components/common/Input';
import './Contact.css';

const Contact = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    setTimeout(() => {
      setLoading(false);
      setSubmitted(true);
      setFormData({ name: '', email: '', subject: '', message: '' });
      setTimeout(() => setSubmitted(false), 5000);
    }, 1000);
  };

  return (
    <div className="contact-page">
      <div className="contact-container">

        {/* ABOUT US SECTION */}
        <section className="about-section">
          <div className="about-inner">
            <h1 className="about-title">{t('about.title')}</h1>
            <p className="about-text">{t('about.welcome')}</p>
          </div>
        </section>

        {/* CONTACT HERO */}
        <div className="contact-hero">
          <h1 className="contact-title">{t('contact.title')}</h1>
          <p className="contact-subtitle">
            {t('contact.subtitle')}
          </p>
        </div>

        {/* MAIN CONTENT */}
        <div className="contact-content">
          <div className="contact-info-grid">

            {/* Phone */}
            <a href="tel:+995577188177" className="contact-card phone-card">
              <div className="contact-card-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
              </div>
              <div className="contact-card-content">
                <h3>{t('contact.phone')}</h3>
                <p>+995 577 188 177</p>
                <span className="contact-card-action">{t('contact.call')}</span>
              </div>
            </a>

            {/* Email */}
            <a href="mailto:store@beautypro.ge" className="contact-card email-card">
              <div className="contact-card-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
              </div>
              <div className="contact-card-content">
                <h3>{t('contact.email')}</h3>
                <p>store@beautypro.ge</p>
                <span className="contact-card-action">{t('contact.send')}</span>
              </div>
            </a>

            {/* Instagram */}
            <a href="https://www.instagram.com/beautypro_storee?igsh=MWlqdnJjdzY4YnR2eQ%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" className="contact-card instagram-card">
              <div className="contact-card-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="2" y="2" width="20" height="20" rx="5" />
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
                </svg>
              </div>
              <div className="contact-card-content">
                <h3>Instagram</h3>
                <p>@Beautypro_storee</p>
                <span className="contact-card-action">{t('contact.follow')}</span>
              </div>
            </a>

            {/* Facebook */}
            <a href="https://www.facebook.com/share/17hgH9n7j7/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="contact-card facebook-card">
              <div className="contact-card-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
                </svg>
              </div>
              <div className="contact-card-content">
                <h3>Facebook</h3>
                <p>BeautyPro</p>
                <span className="contact-card-action">{t('contact.visit')}</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
